import React from 'react'

type Props = {
  status?: string | null
  className?: string
  children?: React.ReactNode
}

const mapStatusClasses = (raw?: string | null) => {
  const s = String(raw || '').toLowerCase()
  switch (s) {
    case 'open':
      return 'bg-blue-100 text-blue-800'
    case 'pending':
      return 'bg-amber-100 text-amber-800'
    case 'accepted':
    case 'awarded':
      return 'bg-green-100 text-green-800'
    case 'shortlisted':
      return 'bg-sky-100 text-sky-800'
    case 'under_consideration':
      return 'bg-purple-100 text-purple-800'
    case 'rejected':
      return 'bg-red-100 text-red-800'
    case 'withdrawn':
      return 'bg-gray-200 text-gray-800'
    case 'closed':
    case 'completed':
      return 'bg-gray-100 text-gray-800'
    case 'pause':
      return 'bg-yellow-100 text-yellow-800'
    default:
      // Fallback
      return 'bg-gray-100 text-gray-800'
  }
}

export const StatusPill: React.FC<Props> = ({ status, className = '', children }) => {
  const classes = mapStatusClasses(status)
  const label = children ?? String(status || '—')
  return (
    <span className={`text-xs px-2.5 py-1 rounded-full font-medium capitalize ${classes} ${className}`.trim()}>
      {label}
    </span>
  )
}

export default StatusPill
